export const ACTIVE_TENANT_KEY = "activeTenantId";

export const LEGACY_BUSINESS_STORAGE_KEYS = Object.freeze([
  "selectedBranchId",
  "selectedWarehouseId",
  "zaytun_soft_current_shift",
]);

export function getActiveTenantId(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(ACTIVE_TENANT_KEY);
}

export function tenantStorageKey(
  domain: string,
  tenantId = getActiveTenantId(),
): string | null {
  if (!tenantId?.trim()) return null;
  return `tenant:${tenantId}:${domain}`;
}

export function getTenantStorageItem(domain: string): string | null {
  const key = tenantStorageKey(domain);
  return key ? localStorage.getItem(key) : null;
}

export function setTenantStorageItem(domain: string, value: string): boolean {
  const key = tenantStorageKey(domain);
  if (!key) return false;
  localStorage.setItem(key, value);
  return true;
}

export function removeTenantStorageItem(domain: string): void {
  const key = tenantStorageKey(domain);
  if (key) localStorage.removeItem(key);
}

export function removeLegacyBusinessStorage(): void {
  for (const key of LEGACY_BUSINESS_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
}
